/* WOLF BROS – "Clear" for the saved height & weight.
   Adds a Clear button next to every "Change" of the size tool (collection "Shop by size")
   and of the size guide (product page: "Your size" pill + the banner in the Size chart tab).
   Clear forgets the height/weight in this browser everywhere (wbFit + wbSize). */
(function () {
  'use strict';
  if (window.__wbSizeClear) return;
  window.__wbSizeClear = true;

  var KEYS = ['wbFit', 'wbSize'];
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };
  var hasSaved = function () {
    try {
      var f = JSON.parse(localStorage.getItem('wbFit') || 'null');
      if (f && +f.h && +f.w) return true;
      var s = JSON.parse(localStorage.getItem('wbSize') || '{}') || {};
      return Object.keys(s).length > 0;
    } catch (e) { return false; }
  };
  var wipe = function () {
    KEYS.forEach(function (k) { try { localStorage.removeItem(k); } catch (e) {} });
    try { window.dispatchEvent(new CustomEvent('wb:size-profile')); } catch (e) {}
  };

  var css = '' +
    '.wbx-clear{display:inline-flex;align-items:center;gap:5px;padding:0;margin-left:12px;background:none;border:0;color:inherit;font:inherit;font-size:inherit;font-weight:700;text-decoration:underline;text-underline-offset:3px;cursor:pointer;opacity:.75;transition:opacity .2s,color .2s}' +
    '.wbx-clear:hover{opacity:1;color:#ff6b6b}' +
    '.wbx-clear svg{width:1.1em;height:1.1em;flex:none}' +
    '.wbx-clear.is-done{color:var(--wb-acc,#E3FF4A);opacity:1;text-decoration:none}' +
    '.wbx-clear--pill{margin-left:auto;height:36px;padding:0 14px;border-radius:999px;border:1px solid rgba(var(--color-foreground),.28);text-decoration:none;font-size:1.25rem;opacity:.9;transition:opacity .2s,color .2s,border-color .2s,background .2s,transform .2s}' +
    '.wbx-clear--pill:hover{color:#ff6b6b;border-color:#ff6b6b;background:rgba(255,107,107,.08);transform:translateY(-1px)}' +
    '.wbx-clear--pill.is-done{border-color:var(--wb-acc,#E3FF4A);color:var(--wb-acc,#E3FF4A);background:none}' +
    '.wbf-mine .wbx-clear{margin-left:10px;font-size:12px}' +
    '.wbf-mine__chg + .wbx-clear{margin-left:10px}' +
    '.wbf-chartyou__top .wbx-clear{font-size:12px;margin-left:10px}' +
    '@keyframes wbxOut{to{opacity:0;transform:translateY(-6px) scale(.98)}}' +
    '.wbx-leaving{animation:wbxOut .3s ease forwards}' +
    '@media (prefers-reduced-motion:reduce){.wbx-leaving{animation:none}}';
  var injectCss = function () {
    if (document.getElementById('wbx-css')) return;
    var st = document.createElement('style'); st.id = 'wbx-css'; st.textContent = css; document.head.appendChild(st);
  };

  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var makeBtn = function (onClick, extra) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'wbx-clear' + (extra ? ' ' + extra : '');
    b.setAttribute('aria-label', 'Clear my saved height and weight');
    b.innerHTML = ICON + '<span>Clear</span>';
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); onClick(b); });
    return b;
  };
  var done = function (b) { b.classList.add('is-done'); b.innerHTML = '✓ <span>Cleared</span>'; };

  /* ---------- collection page: "Shop by size" tool ---------- */
  function clearCollection(btn) {
    var root = btn.closest('.wbsf');
    wipe(); done(btn);
    var box = root && root.querySelector('.wbsf-you');
    if (box) box.classList.add('wbx-leaving');
    var url = new URL(location.href);
    var param = root && root.dataset.param;
    var hadSize = param && url.searchParams.getAll(param).length > 0;
    if (param) url.searchParams.delete(param);
    if (hadSize) url.searchParams.delete('filter.v.availability');
    url.searchParams.delete('page');
    setTimeout(function () { location.href = url.toString(); }, 350);
  }
  function decorateCollection() {
    if (!hasSaved()) return;
    /* top-right of the "your size" box, next to the "Your size / Showing your size" pill */
    each(document.querySelectorAll('.wbsf .wbsf-you'), function (box) {
      var row = box.querySelector('.wbsf-you__row');
      if (!row || row.querySelector('.wbx-clear') || row.querySelector('.wbsf-find')) return;
      row.appendChild(makeBtn(clearCollection, 'wbx-clear--pill'));
    });
  }

  /* ---------- product page: size guide + size chart ---------- */
  function clearProduct(btn) {
    wipe(); done(btn);
    var pill = document.querySelector('.wbf-mine');
    if (pill) pill.classList.add('wbx-leaving');
    setTimeout(function () {
      each(document.querySelectorAll('.wbf-mine, .wbf-colorsize, .wbf-sz'), function (n) { n.remove(); });
      each(document.querySelectorAll('.wbf-has, .wbf-hasnt'), function (l) { l.classList.remove('wbf-has', 'wbf-hasnt'); l.removeAttribute('title'); });
      each(document.querySelectorAll('.wb-sg tr.is-you, .wb-sg tr.is-hit'), function (tr) { tr.classList.remove('is-you', 'is-hit'); });
      var g = document.querySelector('.wb-sg');
      if (g) {
        each(g.querySelectorAll('input[id^="wb-sg-h"], input[id^="wb-sg-w"]'), function (i) { i.value = ''; });
        var res = g.querySelector('.sg-res'); if (res) res.innerHTML = '';
        var banner = g.querySelector('.wbf-chartyou');
        if (banner) {
          banner.innerHTML = '<p>Want to know your size? <button type="button" class="wbf-linkbtn" data-go="find">Enter your height &amp; weight</button> and we\'ll mark it in the chart.</p>';
          var go = banner.querySelector('[data-go]');
          go.addEventListener('click', function () { var t = g.querySelector('.sg-tab[data-pane="find"]'); if (t) t.click(); });
        }
      }
    }, 300);
  }
  function decorateProduct() {
    if (!hasSaved()) return;
    each(document.querySelectorAll('.wbf-mine .wbf-mine__chg'), function (chg) {
      if (chg.parentNode.querySelector('.wbx-clear')) return;
      chg.insertAdjacentElement('afterend', makeBtn(clearProduct));
    });
    each(document.querySelectorAll('.wbf-chartyou__top [data-go="find"]'), function (chg) {
      if (chg.parentNode.querySelector('.wbx-clear')) return;
      chg.insertAdjacentElement('afterend', makeBtn(clearProduct));
    });
  }

  var queued = false;
  function scan() {
    queued = false;
    decorateCollection();
    decorateProduct();
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(scan); } }

  function start() {
    if (!document.querySelector('.wbsf, .wb-sg')) return;
    injectCss();
    scan();
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
